import 'index.sass'
//import 'page/checkout/checkout.js'
import 'page/product/product.js'